<template>
  <div class="bg1" style="padding-left: 10px">
    <div class="search1">
      <el-input
        v-model="keywords"
        placeholder="请输入关键字"
        size="small"
        style="width: 180px"
      ></el-input>
      <el-button
        type="primary"
        size="small"
        class="fr"
        @click="
          dialogVisible = true;
          loginName = '';
          password = '';
        "
        >新增</el-button
      >
    </div>
    <el-table
      :data="data.filter((el) => el.loginName.indexOf(keywords) > -1)"
      style="width: 100%"
    >
      <el-table-column prop="loginName" label="打印员账号"> </el-table-column>
      <el-table-column prop="schoolName" label="所属校区"> </el-table-column>
      <el-table-column label="操作" width="180"
        ><template slot-scope="scope">
          <el-button
            type="primary"
            @click="
              (v) => {
                dialogVisible1 = true;
                loginName = scope.row.loginName;
                password = '';
                password2 = '';
                id = scope.row.id;
              }
            "
            size="small"
            >修改密码</el-button
          >
          <el-button type="danger" @click="del(scope.row)" size="small"
            >删除</el-button
          >
        </template></el-table-column
      > </el-table
    ><el-dialog title="新增打印员" :visible.sync="dialogVisible" width="30%">
      <div class="search">
        <em>账号</em
        ><el-input
          v-model="loginName"
          placeholder="请输入内容"
          size="small"
        ></el-input>
      </div>
      <div class="search">
        <em>密码</em
        ><el-input
          v-model="password"
          placeholder="请输入内容"
          size="small"
        ></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="add()" size="small">添 加</el-button>
      </span> </el-dialog
    ><el-dialog title="修改密码" :visible.sync="dialogVisible1" width="30%">
      <div class="search">
        <em>新密码</em
        ><el-input
          v-model="password"
          placeholder="请输入内容"
          size="small"
        ></el-input>
        <p style="padding:10px 0 0;">
        <em>确认新密码</em
        ><el-input
          v-model="password2"
          placeholder="请输入内容"
          size="small"
        ></el-input>
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible1 = false" size="small"
          >取 消</el-button
        >
        <el-button type="primary" @click="modify()" size="small"
          >修 改</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: [],
      keywords: "",
      dialogVisible: false,
      dialogVisible1: false,
      loginName: "",
      password: "",
      password2:""
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    del(v) {
      this.$confirm("是否删除打印员 “" + v.loginName + "”?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$ajax
            .post("/server/record/print/user/deletePrintUserById", {
              id: v.id,
            })
            .then((res) => {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.getData();
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    modify(v) {
      if(!this.password){
        this.$message({
          message:'请输入密码',
          type:'warning'
        })
        return;
      }
      if(this.password2!=this.password){
        this.$message({
          message:'确认密码和新设置的密码不相同！',
          type:'warning'
        })
        return;
      }
      this.$ajax
        .post("/server/record/print/user/editPassword", {
          password: this.password,
          password2: this.password2,
          loginName: this.loginName,
        })
        .then((res) => {
          this.dialogVisible1 = false;
          this.getData();
        });
    },
    add() {
      this.$ajax
        .post("/server/record/print/user/savePrintUser", {
          loginName: this.loginName,
          password: this.password,
        })
        .then((res) => {
          this.dialogVisible = false;
          this.getData();
        });
    },
    getData() {
      this.$ajax.post("/server/record/print/user/getUserList").then((res) => {
        this.data = res;
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/page/manage/printer.vue